import CompanyCard from '@/components/CompanyCard'
import UserCard from '@/components/UserCard'
import Vue from 'vue'

const personalPendingAccountingNotesModel = vm => ({
  title: vm.$gettext('My Pending Accounting Notes'),
  endpoint: 'accounting-notes',
  countrize: 'country_iso_code',
  noIdLink: true,
  noActions: true,
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'type',
      label: vm.$gettext('Type'),
      sortable: true,
      formatter: (value, key, item) => {
        const color = value === 'credit' ? 'danger' : 'success'
        return '<span class="text-' + color + '">' + value + '</span>'
      }
    },
    {
      key: 'amount',
      label: vm.$gettext('Amount'),
      formatter: (value, key, item) => {
        return value + ' ' + item.currency
      }
    },
    {
      key: 'reference',
      label: vm.$gettext('Reference')
    },
    {
      key: 'account',
      label: vm.$gettext('Account'),
      formatter: (value, key, item) => {
        if (value.model_type.indexOf('User') !== -1) {
          return new Vue({
            ...UserCard,
            parent: this,
            propsData: {
              user: value.owner,
              profilePicture: false,
              withTitles: false,
              withMap: false
            }
          }).$mount().$el.outerHTML
        } else {
          return new Vue({
            ...CompanyCard,
            parent: this,
            propsData: {
              company: value.owner,
              profilePicture: false,
              withTitles: false,
              withContact: false
            }
          }).$mount().$el.outerHTML
        }
      }
    },
    {
      key: 'imputation_date',
      label: vm.$gettext('Imputation Date'),
      sortable: true,
      editable: false,
      required: true
    }
  ],
  includes: ['account.owner', 'shipping'],
  filters: []
})

export default personalPendingAccountingNotesModel
